import { render, staticRenderFns } from "./Brigade.vue?vue&type=template&id=0c854ce5&scoped=true"
import script from "./Brigade.vue?vue&type=script&lang=js"
export * from "./Brigade.vue?vue&type=script&lang=js"
import style0 from "./Brigade.vue?vue&type=style&index=0&id=0c854ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c854ce5",
  null
  
)

export default component.exports